import { Listbox, Transition } from '@headlessui/react';
import React, { useState } from 'react';
import { ChevronDownIcon } from '../icons';

const workplaceTypes = [
  { value: 'On-site', label: 'On-site' },
  { value: 'Remote', label: 'Remote' },
  { value: 'Hybrid', label: 'Hybrid' },
];

const JobWorkplaceTypeListbox = ({ value, onChange }: any) => {
  const [selectedOption, setSelectedOption] = useState(workplaceTypes[0]);

  const handleChange = (option :any) => {
    setSelectedOption(option);
    onChange(option.value);
  };


  function classNames(...classes: any) {
    return classes.filter(Boolean).join(' ')
  }

  return (
    <div className="grid gap-[6px]">
      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
        Workplace Type
      </label>
      <Listbox value={selectedOption} onChange={handleChange}>
        <div className="relative">
          <Listbox.Button className="relative w-full cursor-pointer rounded-lg bg-white py-[5px] pl-3 pr-10 text-left border border-gray-200 focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2">
            <span className={`block truncate text-[14px] ${!selectedOption.value ? 'text-gray-400' : 'text-gray-900'}`}>
              {selectedOption.label}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
            </span>
          </Listbox.Button>
          <Transition
            as={React.Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-10 mt-[9px] left-[0px] bg-white max-w-[100%] min-w-[100%] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
              {workplaceTypes.map((option) => (
                <Listbox.Option
                  key={option.value}
                  value={option}
                  className={({ active }) =>
                    classNames(
                      active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                      'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                    )
                  }
                >
                  {({ selected }) => (
                    <>
                      <span className={`block truncate text-[14px] ${selected ? 'font-medium' : 'font-normal'}`}>
                        {option.label}
                      </span>
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

export default JobWorkplaceTypeListbox;